import { Routes, Route, Navigate, useLocation, type Location } from 'react-router-dom';
import { RootRedirect } from './routes/RootRedirect';
import { AuthPage } from './routes/AuthPage';
import { ProtectedAppRoute } from './routes/ProtectedAppRoute';
import { ProtectedAccountRoute } from './routes/ProtectedAccountRoute';
import { UpgradePage } from './routes/UpgradePage';
import { BillingReturnPage } from './routes/BillingReturnPage';

export default function App() {
  const location = useLocation();
  const state = location.state as { backgroundLocation?: Location } | null;
  const backgroundLocation = state?.backgroundLocation;

  return (
    <>
      <Routes location={backgroundLocation ?? location}>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/login" element={<AuthPage mode="login" />} />
        <Route path="/signup" element={<AuthPage mode="register" />} />
        <Route path="/upgrade" element={<UpgradePage />} />
        <Route path="/billing/return" element={<BillingReturnPage />} />
        <Route path="/app" element={<ProtectedAppRoute />} />
        <Route path="/account" element={<ProtectedAccountRoute />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {backgroundLocation && (
        <Routes>
          <Route path="/upgrade" element={<UpgradePage />} />
        </Routes>
      )}
    </>
  );
}
